import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { setToken } from "../../../config/index";
import changeStatus from "./api";
import EditProfile from "./EditProfile";
import { externalUsers, getCurrentUserRole } from "modules/utilities/utility";
import secureLocalStorage from "react-secure-storage";

const ProfileDropdown = () => {
  const [status, setStatus] = useState("Online");

  const handleLogout = () => {
    setToken("");
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    secureLocalStorage.clear();
    window.location.href = "/";
  };

  const statusIndicator = {
    Online: "d-flex align-items-center  p-1 rounded on-hover",
    Offline:
      "d-flex align-items-center text-danger p-1 rounded offline-on-hover",
  };

  return (
    <Dropdown navbar={true} as="li" className="border-none">
      <Dropdown.Toggle
        bsPrefix="toggle"
        // as={Link}
        className="pe-0 ps-2 bg-white text-primary"
      >
        <div className={statusIndicator[status]}>
          <p
            className="m-0 mx-2 fs-1 text-capitalize"
            style={{ minWidth: "10rem" }}
          >
            {secureLocalStorage.getItem("first_name")}
          </p>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{ minWidth: "98%", left: 6 }}
        className="dropdown dropdown-menu-card align-self-end mt-n1 dropdown-menu-center"
      >
        <div className="bg-white rounded-2 p-2 dark__bg-1000 ">
          {!externalUsers.includes(getCurrentUserRole()) && (
            <div className="p-2 text-black cursor-pointer border-bottom">
              <EditProfile />
            </div>
          )}
          <div
            className="p-2 text-black cursor-pointer border-bottom"
            onClick={handleLogout}
          >
            Log out
          </div>
          {!externalUsers.includes(getCurrentUserRole()) && (
            <div
              className="p-2 pb-1 text-black cursor-pointer "
              onClick={() => {
                setStatus(status === "Online" ? "Offline" : "Online");
                changeStatus(status === "Online" ? "Offline" : "Online");
              }}
            >
              Status {status}
            </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
